import { render, staticRenderFns } from "./create-patient.vue?vue&type=template&id=1d4c48bc&scoped=true"
import script from "./create-patient.vue?vue&type=script&lang=js"
export * from "./create-patient.vue?vue&type=script&lang=js"
import style0 from "./create-patient.vue?vue&type=style&index=0&id=1d4c48bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c48bc",
  null
  
)

export default component.exports